module.exports = __webpack_public_path__ + "static/plain-bold-1ad9af65edf69f93aefac9ae502aed02.otf";